/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOauthGrantResponse
 */
export interface GetOauthGrantResponse {
    /**
     * True iff an oauth_grants row exists for the (user_id, client_id) pair.
     * @type {boolean}
     * @memberof GetOauthGrantResponse
     */
    found: boolean;
    /**
     * True iff the grant exists and revoked_at IS NOT NULL.
     * @type {boolean}
     * @memberof GetOauthGrantResponse
     */
    revoked: boolean;
    /**
     * True iff the user completed onboarding and has EMAIL_SYNCED or SITE_ACCESS_FULL status.
     * @type {boolean}
     * @memberof GetOauthGrantResponse
     */
    mcpAccessEligible: boolean;
    /**
     * JWT staleness floor — reject access tokens whose iat is strictly less than this. Null when found=false.
     * @type {Date}
     * @memberof GetOauthGrantResponse
     */
    tokensValidFrom?: Date | null;
    /**
     * Email of the granting user. Rides along on the grant lookup (which api_mcp already
     * makes and caches per authenticated request) so the MCP server can identify the
     * PostHog person without a second round trip. Null when found=false or the user row
     * has no email.
     * 
     * @type {string}
     * @memberof GetOauthGrantResponse
     */
    email?: string | null;
}

/**
 * Check if a given object implements the GetOauthGrantResponse interface.
 */
export function instanceOfGetOauthGrantResponse(value: object): value is GetOauthGrantResponse {
    if (!('found' in value) || value['found'] === undefined) return false;
    if (!('revoked' in value) || value['revoked'] === undefined) return false;
    if (!('mcpAccessEligible' in value) || value['mcpAccessEligible'] === undefined) return false;
    return true;
}

export function GetOauthGrantResponseFromJSON(json: any): GetOauthGrantResponse {
    return GetOauthGrantResponseFromJSONTyped(json, false);
}

export function GetOauthGrantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOauthGrantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'found': json['found'],
        'revoked': json['revoked'],
        'mcpAccessEligible': json['mcp_access_eligible'],
        'tokensValidFrom': json['tokens_valid_from'] == null ? undefined : (new Date(json['tokens_valid_from'])),
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function GetOauthGrantResponseToJSON(json: any): GetOauthGrantResponse {
    return GetOauthGrantResponseToJSONTyped(json, false);
}

export function GetOauthGrantResponseToJSONTyped(value?: GetOauthGrantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'found': value['found'],
        'revoked': value['revoked'],
        'mcp_access_eligible': value['mcpAccessEligible'],
        'tokens_valid_from': value['tokensValidFrom'] == null ? value['tokensValidFrom'] : value['tokensValidFrom'].toISOString(),
        'email': value['email'],
    };
}

